import { ChangeEvent } from 'react'

import cn from './FileUpload.module.scss'

type FileUploadPropsType = {
  file: Blob | string | null
  accept: string
  inputId: string
  handleUploadFile: (e: ChangeEvent<HTMLInputElement>) => void
}

function FileUpload(props: FileUploadPropsType) {
  const { file, accept, inputId, handleUploadFile } = props

  return (
    <div className={cn.fileUpload}>
      <input
        id={inputId}
        type="file"
        accept={accept}
        onChange={(e) => handleUploadFile(e)}
      />
      <div>
        <label htmlFor={inputId}>Выберите файл</label>
        <span>{file instanceof File ? file.name : 'Файл не выбран'}</span>
      </div>
    </div>
  )
}

export default FileUpload
